import React from "react";
import { useConfig } from "../_util/config-context";

export interface BackDropProps {
  zIndex?: React.CSSProperties["zIndex"];
  style?: React.CSSProperties;
}

export function BackDrop({ zIndex, style = {} }: BackDropProps) {
  const { classPrefix } = useConfig();
  return (
    <div className={`${classPrefix}-backdrop`} style={{ zIndex, ...style }} />
  );
}
